import React, { useState, useEffect } from 'react'
import "./Home.css"
import bcc_logo from "../../assets/images/bcc_logo.png"
import InstitutionCard from '../../components/InstitutionCard/InstitutionCard'
import { institutions_data } from "../../fakeData/institutions.jsx"
import { useNavigate } from 'react-router-dom'
import { searchFunction } from '../../utils/utils'
import { getAllInstitutionAndResearch, getAppsConfig } from '../../services/http'
import Loader from '../../components/Loader/Loader'
import { CDN_BASE_URL } from '../../constants/constants'

const Home = () => {


    const [institutions, setInstitutions] = useState([])
    const [searchText, setSearchText] = useState("")
    const [displayLoader, setDisplayLoader] = useState(true);

    const navigate = useNavigate();

    const handleSearchText = (e) => {
        const value = e.currentTarget.value;
        setSearchText(value)
    }

    useEffect(() => {
        loadInstitutions(searchText);
    }, [searchText]);

    const loadInstitutions = async (label) => {
        const req = await getAllInstitutionAndResearch(label)
        if (req.response && req.reponse.status !== 200) {
            console.log(req.response)
        } else {
            console.log("Okay", req)
            setInstitutions(req?.data)
            setDisplayLoader(false)

        }
    }

    const [appName, setAppName] = useState("Banque Centrale de Congo")
    const [appLogo, setAppLogo] = useState()
    const [appImage, setAppImage] = useState()

    const getAppliParams = async () => {
        let request = await getAppsConfig();
        if (request.response && request.response.status !== 200) {
            console.log(request.response)
        } else {
            console.log("navbar app name ", request)
            setAppName(request.data?.portail.portail_application_name)
            setAppLogo(request.data?.portail.portail_favicon)
            setAppImage(request.data?.portail.image)
        }
    }
    useEffect(() => {
        getAppliParams();
    }, [])

    return (
        <div className='home'>
            <div className='home-blue-content'>
                <div className='home-header d-flex justify-content-between p-2'>
                    <div className='home-logo-box d-flex' onClick={() => navigate("/home")}>
                        <img
                            // src={appLogo !== null ? `${CDN_BASE_URL}${appLogo}` : bcc_logo} 
                            src={bcc_logo}
                            style={{width: 98, height: 60}}
                            className="home-header-logo"
                             />
                        <span className='home-bcc-name my-auto'>
                            {/* {appName} */}
                            Banque Centrale
                        </span>
                    </div>
                    <div className='header-menu-box d-flex justify-content-around'>
                        <div className='home-menu-item mx-2' onClick={() => navigate("/presentation")}>Présentation</div>
                        <div className='home-menu-item mx-2' onClick={() => navigate("/comparateur")}>Comparateur</div>
                        <div className='home-menu-item mx-2' onClick={() => navigate("/simulateur")}>Simulateur</div>
                    </div>
                </div>
                <div className='home-app-desc w-50 p-3'>
                    <p className='home-app-desc-title text-left'>Dispositif de comparaison et de suivi des taux financiers</p>
                    <p className='home-app-desc-subtitle text-left'>Une initiative de la Banque Centrale pour mieux informer les consommateurs.</p>
                </div>

                <div className='w-50 mx-auto'>
                    {/* <label for="floatingInput" className='home-research-label'>Rechercher un établissement financier</label> */}
                    <div className='home-research-label'>Rechercher un établissement financier</div>
                    <div className="mb-3">
                        <input value={searchText} onChange={(e) => handleSearchText(e)} type="text" className="form-control custom-form-control" id="floatingInput" placeholder="" />
                    </div>
                </div>
            </div>
            {displayLoader == false ?
                <div className='home-core-content w-90 d-flex flex-wrap  row mx-auto  py-4'>
                    {institutions?.length !== 0 ? institutions?.map((institution, index) =>
                        <div key={index + institution.id} id={institution.id} className='col-sm-4 col-xs-12'>
                            <InstitutionCard data={institution} />
                        </div>) :
                        <h1>Aucun Etablissement</h1>
                    }
                </div> : <div style={{ marginBottom: "-10%" }}>
                    <Loader />
                </div>
            }


        </div>
    )
}

export default Home